import { create } from 'zustand';

/**
 * Why this browser's time zone did not reach the profile at sign-in, for
 * Settings to show next to the unset zone; null when nothing went wrong.
 */
interface TimeZoneSetup {
  problem: string | null;
  setProblem: (problem: string | null) => void;
}

export const useTimeZoneSetup = create<TimeZoneSetup>((set) => ({
  problem: null,
  setProblem: (problem) => set({ problem }),
}));
